/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../../types/schema.generated';

import gql from 'graphql-tag';
import { CalendarSummaryItemCalendarSummaryFragmentDoc } from './CalendarSummaryItem.generated';
import { SearchCalendarSummaryFunctionCalendarSummaryFragmentDoc } from './search.generated';
import { SortCalendarSummaryFunctionCalendarSummaryFragmentDoc } from './sort.generated';
export type CalendarStatus =
  | 'ACTIVE'
  | 'INACTIVE';

export type CalendarSummaryViewCalendarSummaryFragment = { guid: string, status: Types.CalendarStatus, publicTitle: string, privateTitle: string | null, description: string | null, createdAt: TimeString, assignedStaffs: Array<{ displayName: string, guid: string, priority: number | null }> };

export const CalendarSummaryViewCalendarSummaryFragmentDoc = gql`
    fragment CalendarSummaryViewCalendarSummary on CalendarSummary {
  guid
  ...CalendarSummaryItemCalendarSummary
  ...SearchCalendarSummaryFunctionCalendarSummary
  ...SortCalendarSummaryFunctionCalendarSummary
}
    ${CalendarSummaryItemCalendarSummaryFragmentDoc}
${SearchCalendarSummaryFunctionCalendarSummaryFragmentDoc}
${SortCalendarSummaryFunctionCalendarSummaryFragmentDoc}`;